import { oz } from '@weft/utils';

export const TaxRateSchema = oz.number().min(0).max(100);

export type TaxRate = oz.infer<typeof TaxRateSchema>;